import { useCallback, useMemo, useState } from 'react';
import { useQuery, useMutation } from "@tanstack/react-query";
import { Loading } from '../components/Loading';

import ErrorMessageBox from 'app/components/ErrorMessageBox';
import LineBreak from 'app/components/LineBreak';
import moment from 'moment';
import { Pagination } from 'app/components/Pagination';
import Api, { createFetchErrorMessage } from 'utils/api/Api';

export const UserWarningList = ()=>{
    const [page, setPage] = useState(0);
    
    const { data:userWarningList, isFetching, isError, error} = useQuery({
        queryKey:['warning/list', page],
        queryFn:()=>Api.post(`/api/warning/list?page=${page}`, {})
    });

    const confirmWarningMatate = useMutation({
        mutationFn:(id)=>Api.get(`/api/warning/${id}/confirm`)
    });

    const onConfirmWarning = useCallback((id) => {
        if(confirmWarningMatate.isPending)return;
        if (!window.confirm("선택한 <주의>를 확인했습니까?")) return;
        confirmWarningMatate.mutate(id);
    }, [confirmWarningMatate]);

    const list = useMemo(() => {
        if ( isError ) return <li><ErrorMessageBox message={createFetchErrorMessage(error).message} /></li>;
        
        return userWarningList?.data?.list.map(item=>{
            return (
                <li key={item.id}>
                    <div>
                        <p className="rule">독서활동 제한 {item.restrictedDays}일 추가 </p>
                        <span className="date">{moment(item.createdAt).format("LLL")}</span>
                        <div className="content">
                        <LineBreak content={item.content} />

                        {item.confirmYn !== "Y" && (
                            <button className="btn _sm _blue" onClick={(e) => onConfirmWarning(item.id)} >
                            확인
                            </button>
                        )}

                        {item.confirmYn === "Y" && (
                            <span className="date">
                            &#60;주의&#62;확인: {moment(item.confirmDate).format("LLL")}
                            </span>
                        )}
                        </div>
                    </div>
                </li>
            )
        })
    }, [isError, error, userWarningList, onConfirmWarning]);

    
    return (
        <div className="inner">
            <div className="userWarningContainer" id="userWarningContainer">
                <div className="warning_list">
                    <ul>
                        { list }
                    </ul>
                    <Loading overlay={true} activie={isFetching} />
                </div>
                <Pagination page={userWarningList?.data?.page} totalPage={userWarningList?.data?.totalPages} gotoPage={setPage} />


                <div className="warning_guide" data-aos="fade-zoom-in" data-aos-delay="500" data-aos-duration="1000">
                    <h2 className="sub_hdline">
                        <i className="fa-solid fa-circle-exclamation fs-30"></i> 독서길라잡이 &#60;주의&#62;
                        안내
                    </h2>
                    <div className="contents">
                        <div className="warningInfo">
                            <ul>
                                <li className="p-tb-1">
                                <strong className="fs-18">
                                    1. 불성실한 독서 활동(낙서, 특정 문자로 도배, 반말 등)을 하는 어린이에게는 &#60;주의&#62;가 주어집니다.
                                </strong>
                                <ul className="p-tb-1 fs-16">
                                    <li>- 첫번째 &#60;주의&#62;를 받으면 1일 독서길라잡이 사용이 정지 됩니다.</li>
                                    <li>- 두번째 &#60;주의&#62; 부터는 7일 이상 독서길라잡이 사용이 정지 됩니다.</li>
                                </ul>
                                </li>
                                <li className="p-tb-1">
                                <strong className="fs-18">
                                    2. 성희롱, 욕설, 괴롭힘 등의 과도한 언어폭력은 30일 이상 독서길라잡이 사용이 정지 됩니다.
                                </strong>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                {/* end warning_guide */}
            </div>
        </div>
    );
}